import React, { Component } from 'react';

import Types from '../Types/';
import Field from './Field.js';

class Fields extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-lg-12 mb-2" style={{ borderBottom: '4px solid #1AB2E9' }}>
          <h5>Question Types</h5>
        </div>

        <div className="col-lg-12" style={{ height: '650px', overflow: 'scroll' }}>
          {Object.keys(Types).map(key => {
            return <Field key={Types[key].id} questionType={Types[key]} />;
          })}
        </div>
      </div>
    )
  }
}

export default Fields;